module.exports = __webpack_public_path__ + "media/components/Sponsors/FormTags/Categories/29-af85d1a932897deb0935e2ac397aca60.png";